import { ThreeDots } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { goalsConstants } from 'locale/goals'
import {
  type ButtonHTMLAttributes,
  type DetailedHTMLProps,
  forwardRef
} from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type DotsButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  horizontal?: boolean
}

const DotsButton = forwardRef<HTMLButtonElement, DotsButtonProps>(
  ({ horizontal = true, type = 'button', ...props }, ref) => {
    const { t } = useTranslation(NAMESPACE.GOALS)
    return (
      <DotsWrapper
        ref={ref}
        aria-label={t(goalsConstants.OPEN_MENU)}
        type={type}
        {...props}
      >
        <ThreeDots horizontal={horizontal} />
      </DotsWrapper>
    )
  }
)

DotsButton.displayName = 'DotsButton'

const DotsWrapper = styled.button`
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 0;

  &:focus-visible {
    padding: 2px;
    outline: 2px solid rgba(24, 144, 255, 0.2);
    outline-offset: 1px;
  }
`

export default DotsButton
